import React, { ReactNode } from 'react'
import styled from 'styled-components'

type Props = {
  children: ReactNode
  align?: 'center' | 'left' | 'right' | 'char' | 'justify'
}

const Data = styled.td`
  padding: 1.2rem .6rem;
  text-align: ${({ align }) => align || 'center'};
`

export const TableData: React.FC<Props> = ({
  children,
  align
}) => (
  <Data align={align}>{children}</Data>
)
